// extracted by mini-css-extract-plugin
export default {"ctaContainer":"cta_ctaContainer__jk+nr","cta":"cta_cta__n8l0G","text":"cta_text__djqK2","img":"cta_img__1J93m"};